"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideNoteSprite = void 0;
const pixi_js_1 = require("pixi.js");
const SymbolClasses_1 = require("../../Utils/SymbolClasses");
const inversify_1 = require("inversify");
let SlideNoteSprite = class SlideNoteSprite extends pixi_js_1.Sprite {
    constructor(resource, helper) {
        super();
        this.resource = resource;
        this.helper = helper;
        this.shouldRemove = false;
        this.anchor.set(0.5);
        this.visible = false;
    }
    setTexture(lane) {
        this.texture = this.resource.game.textures["slide_" + lane];
    }
    applyInfo(note) {
        this.note = note;
        this.setTexture(note.lane);
        this.shouldRemove = false;
        this.visible = true;
    }
    update(musicTime) {
        if (!this.visible || this.shouldRemove || !this.note)
            return;
        if (this.note.judge || musicTime > this.note.time + 1) {
            this.shouldRemove = true;
            this.visible = false;
            this.zIndex = 0;
            return;
        }
        const p = this.helper.calc(this.note, musicTime);
        this.position.set(p.x, p.y);
        this.helper.setScale(this, p.scale);
        this.zIndex = p.scale;
    }
};
SlideNoteSprite = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.Resources, SymbolClasses_1.NoteHelper])
], SlideNoteSprite);
exports.SlideNoteSprite = SlideNoteSprite;
//# sourceMappingURL=SlideNoteSprite.js.map